export const CATEGORY_CONFIG = {
  CATEGORY_LIST: {
    endPoint: 'category?scope=pepsi', // includes the query param
    version: 'v1',
    method: 'GET'
  }
};
